import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { toast } from "@performyard/py-components";

import { getIsJobCompleted, getJobErrorMessage, getJobFileDownload } from "../../../selectors/jobs";

export const useCsvDownload = (csvJobID: string | null, onComplete?: () => void) => {
	const downloadUrl = useSelector((state) => (csvJobID ? getJobFileDownload(state, csvJobID) : null));
	const isCompleted = useSelector((state) => (csvJobID ? getIsJobCompleted(state, csvJobID) : null));
	const errorMessage = useSelector((state) => (csvJobID ? getJobErrorMessage(state, csvJobID) : null));

	const [validDownloadUrl, setValidDownloadUrl] = useState(null);

	useEffect(() => {
		if (downloadUrl) {
			setValidDownloadUrl(downloadUrl);
		}
	}, [downloadUrl]);

	useEffect(() => {
		if (csvJobID && downloadUrl) {
			if (isCompleted && validDownloadUrl === downloadUrl) {
				window.open(downloadUrl, "_blank");
				onComplete && onComplete();
			}
		}
	}, [csvJobID, downloadUrl, isCompleted, validDownloadUrl]);

	useEffect(() => {
		if (csvJobID && isCompleted && errorMessage) {
			toast.error(errorMessage);
			onComplete?.();
		}
	}, [csvJobID, isCompleted, errorMessage]);
};
